import { render, staticRenderFns } from "./FundInvestments.vue?vue&type=template&id=d82030aa"
import script from "./FundInvestments.vue?vue&type=script&lang=js"
export * from "./FundInvestments.vue?vue&type=script&lang=js"
import style0 from "./FundInvestments.vue?vue&type=style&index=0&id=d82030aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports